<p data-cy="product-detail-disclaimer-information-text">
  {{ 'i18n.productDetail.productDetailDisclaimer.information' | translate }}
</p>
<p data-cy="product-detail-disclaimer-information-important-text">
  <b>{{ 'i18n.productDetail.productDetailDisclaimer.important' | translate }}</b
  >&nbsp;
  {{ 'i18n.productDetail.productDetailDisclaimer.importantText' | translate }}
</p>
<p data-cy="product-detail-disclaimer-information-allergen-text">
  {{
    'i18n.productDetail.productDetailDisclaimer.informationAllergen' | translate
  }}
</p>
<!-- PFAS Message -->
<ng-container *appShowSplit="[PFASFeatureFlag]">
  <div
    *ngIf="product?.pfasRestricted"
    data-cy="product-detail-disclaimer-information-pfas-container"
    class="product-detail-disclaimer-information-pfas-container"
  >
    <ion-icon
      data-cy="product-detail-disclaimer-information-pfas-icon"
      name="information-circle-outline"
    ></ion-icon>
    <span
      data-cy="product-detail-disclaimer-information-pfas-text"
      [innerHTML]="
        'i18n.productDetail.productDetailDisclaimer.PFASMessage' | translate
      "
    >
    </span>
  </div>
</ng-container>
